const topics = [
  { name: '久久视频', count: '12.8k', icon: 'ri-movie-2-line', hot: true },
  { name: '芒果视频', count: '11.2k', icon: 'ri-tv-2-line', hot: true },
  { name: '97视频', count: '9.6k', icon: 'ri-play-circle-line', hot: true },
  { name: '丝瓜视频', count: '8.4k', icon: 'ri-film-line', hot: false },
  { name: '蓝莓视频', count: '7.9k', icon: 'ri-4k-line', hot: false },
  { name: '91在线视频', count: '6.5k', icon: 'ri-clapperboard-line', hot: false },
  { name: '糖心视频', count: '5.8k', icon: 'ri-heart-line', hot: false },
  { name: '黑桃视频', count: '4.3k', icon: 'ri-vidicon-line', hot: false },
  { name: '高清专区', count: '3.7k', icon: 'ri-hd-line', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-hashtag"></i>
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            大家都在讨论什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            热门话题标签，快速了解当前最受关注的视频平台与内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all ${
                item.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <div className={`w-5 h-5 flex items-center justify-center ${item.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
              <span className={`text-xs ${item.hot ? 'text-primary-400' : 'text-foreground-400'}`}>{item.count}</span>
              {item.hot && (
                <span className="inline-flex items-center gap-0.5 text-xs text-accent-500 font-medium">
                  <i className="ri-fire-fill text-xs"></i>
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}